<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="手机号码">
                  <el-input style="width: 177px;" v-model="queryForm.numbers"></el-input>
              </el-form-item>
              <el-form-item label="发送状态">
<!--                  <el-input  v-model="queryForm.sendStatus"></el-input>-->
                  <el-select v-model="queryForm.sendStatus" placeholder="请选择" size="small" style="width: 177px;" clearable>
                      <el-option label="发送中" :value="0"></el-option>
                      <el-option label="已发送" :value="1"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input style="width: 177px;" v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择用户" labelName="userName"
                               labelValue="userId" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSeachUser" :columns="TEMPLATEUSER_code" :searchs="TEMPLATEUSER_search" dataListUrl="/api/user/findList" entityBeanName="apiUser" queryEntityUrl="/api/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="短信类型">
<!--                  <el-input  v-model="queryForm.smsType"></el-input>-->
                  <el-select v-model="queryForm.smsType" placeholder="请选择" size="small" style="width: 177px;" clearable>
                      <el-option label="商务" :value="1"></el-option>
                      <el-option label="接口" :value="2"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getApiSmsSendList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addApiSmsSend"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editApiSmsSend(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteApiSmsSend(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshApiSmsSendList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="apiSmsSendList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="numbers"
        label="手机号码"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendTimeFormatter"
        label="发送时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendStatus"
        label="发送状态"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.sendStatus == 0 ? '发送中' : '已发送' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendContent"
        label="发送内容"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="statusReason"
        label="接收状态"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.userId && scope.row.templateUser">
                  <div style="text-align: left">用户账号:{{scope.row.templateUser.userName}}</div>
                  <div style="text-align: left">用户号码:{{scope.row.templateUser.userMobile}}</div>
                  <div style="text-align: left">用户状态:{{scope.row.templateUser.userStatus == 0 ? '正常' : '冻结'}}</div>
              </div>
              <span v-else>--</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="smsType"
        label="短信类型"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.smsType == 1 ? '商务' : '接口' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendLog"
        label="发送日志"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkApiSmsSend(scop.row.smsId)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editApiSmsSend(scop.row.smsId)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteApiSmsSend(scop.row.smsId)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="apiSmsSendStates[apiSmsSendState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="apiSmsSend"
          ref="apiSmsSendForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="手机号码"
            prop="numbers"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsSend.numbers"
              :disabled="apiSmsSendState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="发送状态"
            prop="sendStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsSend.sendStatus"-->
<!--              :disabled="apiSmsSendState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                size="small"
                clearable
                style="width: 177px"
                placeholder="请选择"
                v-model="apiSmsSend.sendStatus"
                :disabled="apiSmsSendState == 'check'"
              >
                  <el-option label="发送中" :value="0"></el-option>
                  <el-option label="已发送" :value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="发送内容"
            prop="sendContent"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsSend.sendContent"
              :disabled="apiSmsSendState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="接收状态"
            prop="statusReason"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsSend.statusReason"
              :disabled="apiSmsSendState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="apiSmsSend.userId"-->
<!--              :disabled="apiSmsSendState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="apiSmsSendState == 'check'"
                           labelValue="userId" :value="apiSmsSend.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getUser" :columns="TEMPLATEUSER_code" :searchs="TEMPLATEUSER_search" dataListUrl="/api/user/findList" entityBeanName="apiUser" queryEntityUrl="/api/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="短信类型"
            prop="smsType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsSend.smsType"-->
<!--              :disabled="apiSmsSendState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                size="small"
                clearable
                style="width: 177px"
                placeholder="请选择"
                v-model="apiSmsSend.smsType"
                :disabled="apiSmsSendState == 'check'"
              >
                  <el-option label="商务" :value="1"></el-option>
                  <el-option label="接口" :value="2"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="发送日志"
            prop="sendLog"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsSend.sendLog"
              :disabled="apiSmsSendState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="apiSmsSendState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { TEMPLATEUSER, TEMPLATEUSER_SEARCH } from '@/utils/constant';
import GridSelectU from '@/components/gridselect/index.vue';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetApiSmsSendList();
                    this.getApiSmsSendList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetApiSmsSendList();
                    this.getApiSmsSendList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     numbers: '', //手机号码
                     sendTime: '', //发送时间
                     sendStatus: '', //发送状态 0：发送中 1：已发送
                     sendContent: '', //
                     statusReason: '', //
                     userId: '', //
                     smsType: '', //短信类型：1：商务 2：接口
                     sendLog: '', //发送日志
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                apiSmsSendState: 'add',
                apiSmsSendStates: {
                    add: '新建发送记录',
                    check: '查看发送记录',
                    edit: '修改发送记录'
                },
                TEMPLATEUSER_code: TEMPLATEUSER,
                TEMPLATEUSER_search: TEMPLATEUSER_SEARCH,
                multipleSelection: [],
                apiSmsSendList: [],
                apiSmsSend: {
                    numbers: '', //手机号码
                    sendTime: '', //发送时间
                    sendStatus: '', //发送状态 0：发送中 1：已发送
                    sendContent: '', //
                    statusReason: '', //
                    userId: '', //
                    smsType: 2, //短信类型：1：商务 2：接口
                    sendLog: '', //发送日志
                },
                btnLoading: false,

                rules: {
                    numbers: [{ required: true, message: '手机号码不能为空', trigger: 'blur' }],
                    sendTime: [{ required: true, message: '发送时间不能为空', trigger: 'blur' }],
                    sendStatus: [{ required: true, message: '发送状态不能为空', trigger: 'blur' }],
                    sendContent: [{ required: true, message: '发送内容不能为空', trigger: 'blur' }],
                    statusReason: [{ required: true, message: '接收状态不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    smsType: [{ required: true, message: '短信类型不能为空', trigger: 'blur' }],
                    sendLog: [{ required: true, message: '发送日志不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            // this.getApiSmsSendList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetApiSmsSendList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.apiSmsSendList = [];
            },
            init(){
                this.getApiSmsSendList();
            },
            getUser(value){
                this.apiSmsSend.userId = value
            },
            getSeachUser(value){
                this.queryForm.userId = value
            },
            resetDialog() {
                this.apiSmsSendState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      numbers: '', //手机号码
                      sendTime: '', //发送时间
                      sendStatus: '', //发送状态 0：发送中 1：已发送
                      sendContent: '', //
                      statusReason: '', //
                      userId: '', //
                      smsType: '', //短信类型：1：商务 2：接口
                      sendLog: '', //发送日志
                };
                this.getApiSmsSendList();
            },
            closeDialog() {
                this.showDialog = false
                this.apiSmsSend = {
                      numbers: '', //手机号码
                      sendTime: '', //发送时间
                      sendStatus: '', //发送状态 0：发送中 1：已发送
                      sendContent: '', //
                      statusReason: '', //
                      userId: '', //
                      smsType: 2, //短信类型：1：商务 2：接口
                      sendLog: '', //发送日志
                };
            },
            submitForm() {
                if (this.apiSmsSendState == 'add') {
                    this.$refs.apiSmsSendForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/api/smssend/add`,{ ...this.apiSmsSend }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetApiSmsSendList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.apiSmsSendState == 'edit') {
                    this.$refs.apiSmsSendForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.apiSmsSend.templateUser
                            post(`/api/smssend/edit`,{ ...this.apiSmsSend }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetApiSmsSendList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addApiSmsSend() {
                this.showDialog = true;
                this.apiSmsSendState = 'add';
            },
            checkApiSmsSend(apiSmsSendId) {
                console.log(apiSmsSendId);
                this.currentApiSmsSendId = apiSmsSendId;

                this.getApiSmsSendById();
                this.showDialog = true;
                this.apiSmsSendState = 'check';
            },
            editApiSmsSend(apiSmsSendId) {
                console.log('apiSmsSend', apiSmsSendId);
                if (apiSmsSendId) {
                    this.currentApiSmsSendId = apiSmsSendId;
                    this.getApiSmsSendById();
                } else {
                    this.apiSmsSend = { ...this.apiSmsSend, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.apiSmsSendState = 'edit';
            },
            deleteApiSmsSend(apiSmsSendId) {
                let ids = '';
                if (apiSmsSendId) {
                    ids = apiSmsSendId;
                } else {
                    ids = this.multipleSelection.map((apiSmsSend) => apiSmsSend.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/api/smssend/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetApiSmsSendList();
                                this.getApiSmsSendList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshApiSmsSendList() {
                this.resetApiSmsSendList();
                this.getApiSmsSendList();
            },
            getApiSmsSendList(query = {}) {
                this.loading = true;
                get(`/api/smssend/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.apiSmsSendList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getApiSmsSendById() {
                get(`/api/smssend/get`,{ id: this.currentApiSmsSendId }).then((res) =>{
                    if(res.success){
                      this.apiSmsSend = { ...this.apiSmsSend, ...res.apiSmsSend };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportApiSmsSendList() {
                //this.btnLoading = true;
                exprotExcel(`/api/smssend/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/api/smssend/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/api/smssend/importData`,formData);
              this.refreshApiSmsSendList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getApiSmsSendList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getApiSmsSendList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>